/* eslint-disable @typescript-eslint/no-explicit-any */
import cfg from '../package.json';

type PackageJson = {
  version?: string;
  [key: string]: any;
};

const typedCfg = cfg as PackageJson;

export const appInfo = {
  title: 'Кабінет лабораторії 2.0',
  docTitle: 'Кабінет',
  version: String(typedCfg?.version ?? ''),
};
